import { createAction } from 'redux-actions'

export const setPreviousOrder = createAction('PREVIOUS_ORDER/SET_DATA')
